import { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import { CSSTransition } from "react-transition-group";
import { Segment, Table } from "semantic-ui-react";
import { UserData } from "../../actions/authentificationActions";
import { UsersTableRow } from "./UsersTableRow";

type Props = {
    fetchUsers: () => Promise<void>;
    users: UserData[];
    setUsers: Dispatch<SetStateAction<UserData[]>>;
};

export const UsersTable = ({ users, setUsers, fetchUsers }: Props) => {
    const intl = useIntl();

    const handleRemoveUser = (userGuid: string) =>
        setUsers([...users].filter(x => x.guid !== userGuid));

    return (
        <div className="users-table-container">
            <h1>{intl.formatMessage({ id: "manageUsers" })}</h1>
            <CSSTransition in={users.length > 0} timeout={100} classNames="fade" unmountOnExit>
                <Segment>
                    <Table basic="very" compact="very">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                    {intl.formatMessage({ id: "user" })}
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    {intl.formatMessage({ id: "authority" })}
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    {intl.formatMessage({ id: "role" })}
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    {intl.formatMessage({ id: "actions" })}
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {users.map(user => (
                                <UsersTableRow
                                    key={user.guid}
                                    user={user}
                                    handleRemoveUser={handleRemoveUser}
                                    fetchUsers={fetchUsers}
                                />
                            ))}
                        </Table.Body>
                    </Table>
                </Segment>
            </CSSTransition>
        </div>
    );
};
